import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const NoAgentResult = () => (
  <div className={cx('NoAgentResult')}>
    <div className={cx('container')}>
      <div className={cx('inner')}>
        <div className={cx('error')}>
          <h5 className={cx('title')}>잠시후 다시 이용하여 주십시요</h5>
          <p className={cx('txt')}>
            일시적인 오류로 조회하신 여정의 판매사 정보를
            <br />
            불러올 수 없습니다
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default NoAgentResult;
